module.exports = __webpack_public_path__ + "play_s.0ec0554a.png";